// import "bootstrap";
import "what-input";
import "bootstrap/js/dist/collapse";

(function (jQuery) {
  "use strict";

  /**
   * Footer scroll box
   * ================
   */

  var line1 = document.querySelector("line1");
  var scrollValue = 0;
  var scrollTimeout = false
  var move = '';
  
  jQuery(window).on("scroll", function (event) {
    // console.log(window.scrollY);
    var pos = window.scrollY/4 - 4500;

    jQuery(".line1").animate({ left: pos + "px" }, 10, "linear");




  });



  /**
   * Mark links as external or local
   * ================
   */
  
  // jQuery("a:not(.sbi_photo)").each(function () {
  //   if (location.hostname === this.hostname || !this.hostname.length) {
  //     jQuery(this).addClass("is-local-link");
  //   } else {
  //     jQuery(this).addClass("is-external-link");
  //     var site = jQuery(this.text);
  //   }
  // });
  jQuery("a:not(.sbi_photo)").each(function () {
    let siteLink = jQuery(this).attr("href");

    if(siteLink.length && siteLink.startsWith('http') || siteLink.startsWith('https')) {
      let urlParser = new URL(siteLink);
      let host = urlParser.hostname;

      if (location.hostname === host) {
        jQuery(this).addClass("is-local-link");
      } else {
        jQuery(this).addClass("is-external-link");
      }
    }
  });

  /**
   * Filter artists
   * ================
   */
  var jQuerybtns = jQuery('.button').click(function() {
    if (this.id == 'all') {
      jQuery('#ct > div').show();
    } else {
      var jQueryel = jQuery('.' + this.id).show();
      jQuery('#ct > div').not(jQueryel).hide();
    }
    jQuerybtns.removeClass('active');
    jQuery(this).addClass('active');
  })


  
})(jQuery);

jQuery(document).ready(function () {
  
  /**
   * YouTube
   * ================
   */
  jQuery(window).on("scroll", function (event) {

    jQuery('.youtube-play').hide();
    
    var jQueryinput = jQuery("body").find(".youtube-placeholder");

    var jQueryinput_src = jQuery("body").find(".youtube-placeholder").attr('src');

    jQueryinput.bind('click', function () {
      var video = '<iframe title="YouYube-upotus" class="youtube-video-iframe" src="' + jQuery(this).attr('data-video') + '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>';
      jQuery(this).replaceWith(video);
      jQuery('.ytp-button').trigger('click');
    });

    jQueryinput.trigger('click');

    jQuery('.rl-instagram').css('display', 'block');
    
  });


  jQuery('.youtube-play').on('click', function () {

    var jQueryinput = jQuery(this).next(".youtube-placeholder");

    var jQueryvideo_url = jQuery(this).next(".youtube-placeholder").attr('data-video');

    jQuery('.youtube-play').hide();

    var video = '<iframe title="YouTube-upotus" class="youtube-video-iframe" src="' + jQueryvideo_url + '"></iframe>';
    
    jQueryinput.replaceWith(video);

    jQuery(this).closest('.youtube-placeholder').replaceWith(video);

    jQuery('.ytp-button').trigger('click');

  });
  
  
  let lang = jQuery('html').attr('lang');
  let navEl = jQuery('.lang-nav-custom');
  
  if(lang && navEl.length) {
    jQuery('.lang-item-' + lang).addClass('current-lang');
  }
});